// extracted by mini-css-extract-plugin
module.exports = {"dl":"PollMeta_dl__duiLY"};